const imgDesktop = {
    init: function() {
        var elts = document.querySelectorAll('img[data-desktop]');
        if(elts) {
            [].forEach.call(elts, function(elt) {
                elt.src=elt.dataset.desktop;
                if(elt.hasAttribute("data-lazy-src")) {
                    elt.dataset.lazySrc = elt.dataset.desktop;
                }
            });
            [].forEach.call(elts, function(elt) {
                elt.src=elt.dataset.desktop;
                if(elt.hasAttribute("data-lazy-src")) {
                    elt.dataset.lazySrc = elt.dataset.desktop;
                }
            })
        }
        
        var eltsBgd = document.querySelectorAll('*[data-desktop-bgd]');
        if(eltsBgd) {
            [].forEach.call(eltsBgd, function(elt) {
                elt.style.backgroundImage = "url('"+elt.dataset.desktopBgd+"')";
            })
        }
    }
}
if(!window.matchMedia("(max-width: 767px)").matches) {
    imgDesktop.init();
}


// WEBPACK FOOTER //
// ./src/img-desktop.js